export const CodeEnum = Object.freeze({
    ok: "ok",
    cancel: "cancel",
    error: "error",
    OK: "OK",
    ERROR: "ERROR",
    CANCEL: "CANCEL",
})
